import request from "@/axios.js";

export default class Provider {
	/**
	 * Provider class
	 * @property {string} firstname - a firstname.
	 * @property {string} lastname - a lastname.
	 * @property {string} email - an email.
	 * @property {number} role - a role.
	 * @property {string} phone - a phone.
	 * @property {number} status - a status.
	 * @property {string} commentary - a commentary.
	 * @property {boolean} hasAccess - a hasAccess.
	 * @property {number} rate - a rate.
	 * @property {string} society - an society.
	 * @property {string} website - an website URL.
	 * @property {number} service_id - ID of a service for logic in form only, not included in constructor.
	 * @property {Array} service_id_list - List of Number values of service ids.
	 * @property {Array} type - List of Number values of service ids.
	 */
	constructor(provider) {
		this.id = provider.id || null;
		this.status = provider.status || 0;
		this.commentary = provider.commentary;
		this.rate = provider.rate;
		this.society = provider.society;
		this.website = provider.website;
		this.service_id_list = provider.service_id_list;
		this.type = provider.type;
		this.refund = provider.refund;
		this.tag_ids = provider.tag_ids || [];
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * It does not need service_id_list which is generated while the creation process,
	 * neither does service_id which is only a tool inside forms.
	 * @return {object} provider object
	 */
	static getFormFields(){
		return {
			status: 0,
			commentary: null,
			hasAccess: null,
			rate: null,
			society: null,
			website: null,
			type: null,
			refund: null,
			tag_ids: null
		};
	}

	compare(contactToCompare){
		for(let key in contactToCompare) {
			if(this[key] != contactToCompare[key]){
				return false;
			}
		}
		return true;
	}
	static async getAll(){
		return new Promise((resolve, reject) => {
			request.get("/providers/all/")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getWsAll(id){
		return new Promise((resolve, reject) => {
			request.get("/providers/allws?service_id="+ id)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getNetlinkProvider(){
		return new Promise((resolve, reject) => {
			request.get("/providers/getAllProvidersNetlinkMostUsed")
				.then(res => {
					const netlinkProvider = res.data;
					resolve(netlinkProvider);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	getServiceIdList(){
		// /getsu/:id
		request.get("/providersServices/getsu/" + this.id)
			.then(res => {
				//console.log(res);
				this.service_id_list = res.data;
				/*
				 * for(let service of res.data){
				 *   this.service_id_list.push(service.service_id)
				 * }
				 */
				return this.service_id_list;
			})
			.catch(err => {
				//console.log(err);
			});
	}

	deleteAllServices(){
		request.delete("/providersServices/delete/" + this.id)
			.then(res => {
				//console.log(res);
			})
			.catch(err => {
				//console.log(err);
			});
	}

	delete(callback){
		request.delete("/providersServices/delete/" + this.id)
			.then(res => {
				request.delete("/providers/delete/" + this.id, {
					data: {
						id: this.id
					}
				})
					.then(res => {
						callback(null, res);
					})
					.catch(err => {
						callback(err, null);
					});
			})
			.catch(err => {
				//console.log(err);
			});

	}
}
